export const LIMIT_FIELDS = {
	LIMIT_TYPE: 'limit_type',
	LIMIT_SIZE: 'limit_size'
};

export const LIMIT_TYPES = {
	VIEWS: 'views',
	PURCHASES: 'purchases'
};
